import { ReactComponent as GitHub } from '../../images/icons/github.svg';
import { ReactComponent as AngelList } from '../../images/icons/angellist.svg';
import { ReactComponent as LinkedIn } from '../../images/icons/linkedin.svg';
import { ReactComponent as Twitter } from '../../images/icons/twitter.svg';

export const socialLinks = [
  { id: 0, icon: GitHub, link: 'https://github.com/samiullahbahadur' },
  { id: 1, icon: AngelList, link: 'https://angel.co/u/samiullah-bahadur' },
  {
    id: 2,
    icon: LinkedIn,
    link: 'https://www.linkedin.com/in/samiullah-bahadur/',
  },
  { id: 3, icon: Twitter, link: 'https://twitter.com/Samiull88496331' },
];

export default 'SocialLinks';
